module.exports = __webpack_public_path__ + "static/media/19ESCAP7.56e0f2fe.jpg";